import { z } from 'zod'

/**
 * Mirrors MAX_CUSTOM_INSTRUCTIONS_CHARS in paxton_app/paxton_settings/service.py.
 * The backend rejects anything longer with a 400, so keep the two in step.
 */
export const kMaxCustomInstructionsChars = 2000

export const UserSettingsGetSchema = z.object({
  research_contact_prompt_completed: z.boolean().optional(),
  default_jurisdiction: z.string().nullable().optional(),
  // Absent rather than null when the user has never set it: the backend only emits keys
  // that have at least one stored row.
  custom_instructions: z.string().nullable().optional(),
})

export const UserSettingsPatchSchema = z.object({
  default_jurisdiction: z.string().nullable().optional(),
  custom_instructions: z.string().max(kMaxCustomInstructionsChars).optional(),
})

export const SettingsGetResponseSchema = z.object({
  success: z.boolean(),
  data: z.object({
    user: UserSettingsGetSchema,
    organization: z.record(z.any()).optional().default({}),
  }),
})

/**
 * The PATCH route returns the user's full settings, not an echo of the request, so this parses
 * with the permissive Get schema. Reusing the request schema here would apply request-only
 * constraints (the length cap, non-nullability) to server-returned data and throw on values the
 * backend legitimately produces, breaking every settings save for that user.
 */
export const UserSettingsPatchResponseSchema = z.object({
  success: z.boolean(),
  data: UserSettingsGetSchema,
})

export type SettingsGetResponse = z.infer<typeof SettingsGetResponseSchema>
export type UserSettingsPatchResponse = z.infer<typeof UserSettingsPatchResponseSchema>
